import { useState } from 'react';
import { toast } from 'sonner';
import { connectivityAPI } from '../../api/connectivityApis/connectivity.api'; 

export const useConnectivity = () => {
  const [isStarting, setIsStarting] = useState(false);

  const startSession = async (
    expertCode: string, 
    sessionType: 'chat' | 'call' | 'video', 
    categoryId: number | null, 
    intakeData?: any 
  ) => {
    try {
      setIsStarting(true);
      // 🟢 QUEUE UPDATE: This now returns either { sessionId } OR { isQueued, queueRank }
      const data = await connectivityAPI.initiateSession({
        expertCode,
        sessionType,
        categoryId,
        intakeData, 
      });
      return data; 
    } catch (error: any) {
      const msg = error.response?.data?.message || 'Failed to start session. Please check your balance.';
      toast.error(msg);
      return null;
    } finally {
      setIsStarting(false);
    }
  };

  return { startSession, isStarting };
};